



































import { DistrictModel, TownModel } from '@/libs/Api';
import { districtsStore } from '@/libs/districts/+state/store';
import { CrudAction } from '@/libs/core/+state/models/crud-action';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import Page from '@/Page.vue';
import { Component, Prop, Ref, Watch } from 'vue-property-decorator';

import DistrictDialog from '@/libs/settings/components/DistrictDialog.vue';
import TownItems from '../components/TownItems.vue';

@Component({
    components: {
        DistrictDialog, TownItems
    }
})
export default class Districts extends Page {

    filterActive = true;
    @Prop() tenantId!: string;

    get loading(): boolean {
        return districtsStore.useGetter(CrudGetter.Pending);
    }

    get districts(): DistrictModel[] {
        return [...districtsStore.useGetter(CrudGetter.Data)];
    }

    @Ref() districtDialog!: DistrictDialog;
    
    createItemClick () {
        this.districtDialog.open();
    }

    openDistrictClick (v: DistrictModel) {
        this.districtDialog.open(v.id);
    }

}
